export const NODE_STATES = {
    READY: 'ready',
    NOT_READY: 'not ready',
    SANDBOX: 'sandbox',
};
